import { Component } from '@angular/core';

@Component({
  selector: 'app-validation-page-c',
  templateUrl: './validation-page-c.component.html',
  styleUrls: ['./validation-page-c.component.css'],
})
export class ValidationPageCComponent {
  title1 = 'Validation';
  title = 'Seller Information';
  title2 = 'Document Validation';
}
